// Haalt een Microsoft Graph access-token op met specifieke delegated scopes
// (bijv. Notes.Read.All voor OneNote). Los van authHelpers.js — die levert het
// id-token voor onze eigen backend; dit levert een Graph-access-token (aud=graph).
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { getMsalInstance } from "./msalSingleton";

export async function acquireGraphToken(scopes) {
  const msalInstance = getMsalInstance();
  if (!msalInstance) throw new Error("Niet ingelogd");
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (!account) throw new Error("Geen actief Microsoft-account");
  const request = { scopes, account };
  try {
    const r = await msalInstance.acquireTokenSilent(request);
    return r.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      // Eerste keer of nieuwe scope → toestemming via popup.
      const r = await msalInstance.acquireTokenPopup(request);
      return r.accessToken;
    }
    throw err;
  }
}
